import { jsx as t } from "react/jsx-runtime";
const a = "flex w-full min-h-screen py-5 [&>*]:h-fit [&>*]:m-auto", o = ({ children: e }) => /* @__PURE__ */ t("main", { role: "main", className: a, children: e });
export {
  a as CENTERED_LAYOUT_BASE_CLASSNAME,
  o as default
};
